<template>
	<div class="title_box">
	  <p class="table_title_box">
		<span class="table_title_text">{{ title }}</span>
	  </p>
	  <el-button v-if="button" type="primary" @click="handleClick">{{ button }}</el-button>
	</div>
  </template>
  <script>
import i18n from '../../locales/index'

  export default {
	props: {
	  title: {
		type: String,
		default: i18n.t('components_column_title_column_title_6')
	  },
	  button: {
		type: String,
		default: ''
	  }
	},
	methods: {
	  handleClick() {
		this.$emit('downData');
	  }
	}
  };
  </script>
  <style lang="less" scoped>
  .title_box {
	display: flex;
	justify-content: space-between;
	margin-bottom: 10px;
	.table_title_box {
	  padding: 0 3px;
	  height: 10px;
	  background-color: rgb(213, 226, 255);
	  position: relative;
	  top: 10px;
	  margin: 5px 0;
	}
	.table_title_text {
	  display: inline-block;
	  height: 22px;
	  line-height: 22px;
	  color: #0f1b34;
	  font-size: 16px;
	  padding: 0 3px;
	  opacity: 1;
	  position: relative;
	  top: -10px;
	  font-weight: bold;
	}
  }
  </style>
